import { MessageService } from "./../services/message.service";
import { Component, OnInit, ViewChild, ElementRef } from "@angular/core";
import { HotelService } from "../services/hotel.service";
import { Hotel } from "../hotel";
import { DataTableDirective } from "angular-datatables";
import { Subject } from "rxjs/Subject";
import { Router } from "@angular/router";
import * as jsPDF from "jspdf";
import * as html2canvas from "html2canvas";
import {
  Http,
  RequestOptions,
  Headers,
  ResponseContentType
} from "@angular/http";

@Component({
  selector: "app-listhotel",
  templateUrl: "./listhotel.component.html",
  styleUrls: ["./listhotel.component.css"]
})
export class ListhotelComponent implements OnInit {
  model = new Hotel();
  hotel: any;
  value: any;
  rates: any;
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  @ViewChild("print")
  print: ElementRef;
  profiles: any;
  constructor(
    private router: Router,
    private http: Http,
    private messageService: MessageService,
    private hotelService: HotelService
  ) {
    this.getHotel();
  }

  ngOnInit() {
    this.hotel = [];
    this.getHotelList();
  }
  total: any = 0;
  totalPending: any = 0;
  totalPaid: any = 0;
  discount: any = 0;
  getHotelList() {
    this.hotelService.getHotelList().subscribe(response => {
      this.hotel = response;
      this.hotel.forEach(element => {
        this.totalPending += parseFloat(element.pending_amount);
        this.totalPaid += parseFloat(element.paid_amount);
        this.total += parseFloat(element.total_payment);
        this.discount += parseFloat(element.discount);
      });
      this.totalPending.toFixed(2);
      this.totalPaid.toFixed(2);
      this.total.toFixed(2);
      this.discount.toFixed(2);
      this.dtTrigger.next();
    });
  }

  getHotel() {
    this.hotelService.getAllHotelinmaterial().subscribe(profiles => {
      this.profiles = profiles;
      //console.log(profiles);
    });
  }
  obj: any;
  getHotelRates(val) {
    $("#save").removeAttr("disabled");
    $("#save").css("display", "block");
    $("input[name$='qty']").val("0");
    $("input[name$='amt']").val("0");
    $("input").css("border", "1px solid #ccc");
    this.obj = { hotelid: val };
    this.hotelService.getHotelRates(this.obj).subscribe(rates => {
      this.rates = rates[0];
      Object.assign(this.model, this.rates);
      this.model.total = 0;
    });
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }
  setActive(menu) {
    $("li").removeClass();
    $("#" + menu).addClass("active");
  }

  formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  searchReport() {
    this.totalPending = this.totalPaid = this.total = this.discount = 0;

    let from = this.formatDate(this.model.fromdate); //.toISOString().substring(0, 10);
    let to = this.formatDate(this.model.todate); //.toISOString().substring(0, 10);
    let hotelid = this.model.hotelid;
    this.obj = {
      fromdate: from,
      todate: to,
      hotelid: hotelid
    };
    if (hotelid == undefined || hotelid == 0) {
      this.hotelService.getSearchHotelList(this.obj).subscribe(response => {
        $("#print")
          .DataTable()
          .destroy();
        this.hotel = response;
        this.hotel.forEach(element => {
          this.totalPending += parseFloat(element.pending_amount);
          this.totalPaid += parseFloat(element.paid_amount);
          this.total += parseFloat(element.total_payment);
          this.discount += parseFloat(element.discount);
        });
        this.totalPending.toFixed(2);
        this.totalPaid.toFixed(2);
        this.total.toFixed(2);
        this.discount.toFixed(2);
        this.dtTrigger.next();
      });
    } else {
      this.router.navigate(["/searchreport", hotelid, from, to]);
    }
  }
  dsbl: any;
  restorepage;
  printcontent;
  prints() {
    $("#printing").text("Downloading PDF...");

    $(".act").css("display", "none");
    $(".dataTables_info").css("visibility", "hidden");
    $(".dataTables_paginate").css("visibility", "hidden");
    $(".dataTables_length").css("visibility", "hidden");
    $(".dataTables_filter").css("visibility", "hidden");

    this.dsbl = true;
    setTimeout(() => {
      this.dsbl = false;
    }, 5000);
    window.print();

    let from = this.formatDate(this.model.fromdate); //.toISOString().substring(0, 10);
    let to = this.formatDate(this.model.todate); //.toISOString().substring(0, 10);
    let hotelid = this.model.hotelid;
    this.obj = {
      fromdate: from,
      todate: to,
      hotelid: hotelid
    };

    let server;
    if (location.hostname != "localhost") {
      server =
        "http://" + location.hostname + "/tejashreecode/index.php/hotel/";
    } else {
      server =
        "http://" +
        location.hostname +
        "/tejashree/tejashreecode/index.php/hotel/";
    }

    let headers = new Headers({ "Content-Type": "application/json" });
    headers.append("Accept", "application/json");
    let options = new RequestOptions({ headers: headers });

    return this.http
      .post(server + "pdf_report", this.obj, {
        responseType: ResponseContentType.Blob
      })
      .map(res => {
        return {
          filename: "Report.pdf",
          data: res.blob()
        };
      })
      .subscribe(
        res => {
          console.log("start download:", res);
          let url = window.URL.createObjectURL(res.data);
          let a = document.createElement("a");
          document.body.appendChild(a);
          a.setAttribute("style", "display: none");
          a.href = url;
          a.download = res.filename;
          a.click();
          window.URL.revokeObjectURL(url);
          a.remove();
        },
        error => {
          console.log("download error:", JSON.stringify(error));
        },
        () => {
          console.log("Completed file download.");
          location.reload();
          $("#printing").text("Print");
          $("#print")
            .DataTable()
            .destroy();
          $(".act").css("display", "block");
          // $('.dataTables_info').css('visibility', 'visible')
          // $('.dataTables_paginate').css('visibility', 'visible')
          // $('.dataTables_length').css('visibility', 'visible')
          // $('.dataTables_filter').css('visibility', 'visible')
          this.dtTrigger.next();
        }
      );
  }
  data;
  deleteBill(billNo: string) {
    if (confirm("Are you sure to delete bill")) {
      this.data = { bill_no: billNo };
      this.hotelService.deleteBill(this.data).subscribe(response => {
        this.totalPending = 0;
        this.totalPaid = 0;
        this.total = 0;
        this.discount = 0;
        this.getHotelList();
        $("#print")
          .DataTable()
          .destroy();
      });
    }
  }

  paybill(bill_no) {
    $(".pay_" + bill_no).hide();
    $(".paypartial_" + bill_no).hide();
    $(".delete_" + bill_no).hide();

    this.hotelService.addpayBillDirect({ bill_no: bill_no }).subscribe(
      response => {
        if (response.icon == "ok") {
          $(".pending_" + bill_no)
            .removeClass("badge-error")
            .addClass("badge-success")
            .html("Paid");
        } else {
            $(".pay_" + bill_no).show();
            $(".paypartial_" + bill_no).show();
            $(".delete_" + bill_no).show();
        }
        this.messageService.showMessage(
          "div#msg",
          "alert-" + response.bg,
          response.response,
          "glyphicon-" + response.icon
        );
      },
      err => {
        console.log("Json Response Error");
      }
    );
   
  }
}



// WEBPACK FOOTER //
// D:/xampp/htdocs/tejashree/src/app/listhotel/listhotel.component.ts